"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EmptyBodyFetchGraphqlError = require("./EmptyBodyFetchGraphqlError");
Object.keys(_EmptyBodyFetchGraphqlError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmptyBodyFetchGraphqlError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmptyBodyFetchGraphqlError[key];
    }
  });
});
var _FetchGraphqlError = require("./FetchGraphqlError");
Object.keys(_FetchGraphqlError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FetchGraphqlError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FetchGraphqlError[key];
    }
  });
});
var _NonOkResponseFetchGraphqlError = require("./NonOkResponseFetchGraphqlError");
Object.keys(_NonOkResponseFetchGraphqlError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NonOkResponseFetchGraphqlError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NonOkResponseFetchGraphqlError[key];
    }
  });
});
//# sourceMappingURL=index.js.map